import { RUM } from '@qualtrics/page-metrics/lib/rumLogger';
import { SumoLogger } from '@qualtrics/page-metrics/lib/sumoService';
import { LogPostQueueService } from '@qualtrics/page-metrics/lib/logPostQueueService';

const CLIENT_LOGGING_URL = '/rum/genesis-dev-client-logging?';

let metadata;
let logQueue;
let logger;

export function initializeMetadata(rumMetadata) {
  metadata = rumMetadata;
  // eslint-disable-next-line new-cap
  logQueue = LogPostQueueService('globalWrapperClient', metadata);
  // eslint-disable-next-line new-cap
  logger = SumoLogger(logQueue);
}

export function initializeLogsObserver(metricsDelegate) {
  const timingBaseline = Date.now();
  metricsDelegate.subscribeObserver({
    onAppInteractive: () => {
      RUM.setMetricTime('home.global_wrapper.rum', 'appInteractive');
    },
    onAppComplete: () => {
      RUM.setMetricTime('home.global_wrapper.rum', 'appComplete');
      RUM.postComponentTimings(
        'home.global_wrapper.rum',
        timingBaseline,
        metadata,
      );
    },
    onVisibilityEvalFailure: (
      errorMessage,
      contextType,
      additionalKeyPairs,
    ) => {
      logger?.logError?.(errorMessage, additionalKeyPairs);
    },
    onBundleFailure: (errorMessage, additionalKeyPairs) => {
      logger?.logError?.(errorMessage, additionalKeyPairs);
    },
    onSessionStorageWriteFailure: (errorMessage, additionalKeyPairs) => {
      logger?.logError?.(errorMessage, additionalKeyPairs);
    },
    error: (message, additionalKeyPairs) => {
      logger?.logError?.(message, additionalKeyPairs);
    },
    onStorageSnapshot: (snapshot) => {
      logQueue?.addToLogQueue(
        { logType: 'storageSnapshot', ...snapshot },
        CLIENT_LOGGING_URL,
      );
    },
    onAmplitudeRequest: (amplitudeRequestLog) => {
      logQueue?.addToLogQueue(
        { logType: 'amplitudeRequest', ...amplitudeRequestLog },
        CLIENT_LOGGING_URL,
      );
    },
  });
}
